import React from "react";

export default function TokenStart() {
  const data =[
    {
      id:1
    },
    {
      id:1
    },
    {
      id:1
    },
    {
      id:1
    },
    {
      id:1
    },
    {
      id:1
    },
    {
      id:1
    },
    {
      id:1
    },
    {
      id:1
    },

  ]
  return (
    <div id="token">
      <section className="lg:pt-[100px] py-[50px]">
        <div className="container lg:px-10 px-4">
          <div className="lg:mb-[80px] max-w-[1000px] mx-auto lg:px-10 px-4">
            <h3 className="text-center font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4]  lg:text-[35px] sm:text-[25px] text-[22px] mb-8">
              Token Distribution
            </h3>
            <p className="text-center lg:text-[18px] sm:text-[15px] text-[14px]">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </p>
          </div>
          <div className="flex lg:flex-row  gap-8 flex-col justify-center items-start">
            <div className="flex-1 lg:mt-0 mt-[60px]">
              <div>
                <img src={process.env.PUBLIC_URL +'/assets/tokenomics.png'} className="  mx-auto" />
              </div>
            </div>
            <div className="flex-1">
           
                   <div className="flex justify-between px-5 py-3 bg-[#751EFE] text-white rounded-lg mb-3">
              <h4 className='capitalize font-bold'>whitelist </h4>
              <h4  className='capitalize font-bold'>3600000 </h4>
              
             </div>
             <div className="flex justify-between px-5 py-3 bg-[#751EFE] text-white rounded-lg mb-3">
              <h4 className='capitalize font-bold'> private A</h4>
              <h4  className='capitalize font-bold'>45000000 </h4>
             </div>
              <div className="flex justify-between px-5 py-3 bg-[#751EFE] text-white rounded-lg mb-3">
              <h4 className='capitalize font-bold'> private B </h4>
              <h4  className='capitalize font-bold'>300000</h4>
             </div>
             <div className="flex justify-between px-5 py-3 bg-[#751EFE] text-white rounded-lg mb-3">
              <h4 className='capitalize font-bold'>pre-sale A</h4>
              <h4  className='capitalize font-bold'>1800000 </h4>
             </div>
             <div className="flex justify-between px-5 py-3 bg-[#751EFE] text-white rounded-lg mb-3">
              <h4 className='capitalize font-bold'>public offering</h4>
              <h4  className='capitalize font-bold'>1200000 </h4>
             </div>
             <div className="flex justify-between px-5 py-3 bg-[#751EFE] text-white rounded-lg mb-3">
              <h4 className='capitalize font-bold'>community</h4>
              <h4  className='capitalize font-bold'>1000000 </h4>
             </div><div className="flex justify-between px-5 py-3 bg-[#751EFE] text-white rounded-lg mb-3">
              <h4 className='capitalize font-bold'>advisors and leagal</h4>
              <h4  className='capitalize font-bold'>50000000 </h4>
             </div>

             <div className="flex justify-between px-5 py-3 bg-[#751EFE] text-white rounded-lg mb-3">
              <h4 className='capitalize font-bold'>marketing and PR </h4>
              <h4  className='capitalize font-bold'>20000000 </h4>
             </div>
             <div className="flex justify-between px-5 py-3 bg-[#751EFE] text-white rounded-lg mb-3">
              <h4 className='capitalize font-bold'>product development </h4>
              <h4  className='capitalize font-bold'>20000000 </h4>
             </div>
             <div className="flex justify-between px-5 py-3 bg-[#751EFE] text-white rounded-lg mb-3">
              <h4 className='capitalize font-bold'>partnerships and ecosystem </h4>
              <h4  className='capitalize font-bold'>30000000 </h4>
             </div>
             <div className="flex justify-between px-5 py-3 bg-[#751EFE] text-white rounded-lg mb-3">
              <h4 className='capitalize font-bold'>initial liquidity and market making </h4>
              <h4  className='capitalize font-bold'>50000000 </h4>
             </div>
             <div className="flex justify-between px-5 py-3 bg-[#751EFE] text-white rounded-lg mb-3">
              <h4 className='capitalize font-bold'>reserve </h4>
              <h4  className='capitalize font-bold'>31900000 </h4>
             </div>

             
          
             
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
